export default "__VITE_ASSET__cab63db4__"